import { Component, OnInit, OnDestroy } from '@angular/core';
import { SponsorsService } from '../services/sponsors.service';
import { SponsorInfo } from '../sponsors.interfaces';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-sponsors-listing',
  templateUrl: './sponsors-listing.component.html',
})
export class SponsorsListingComponent implements OnInit, OnDestroy {
  loading = true;
  sponsors: SponsorInfo[];

  private sub$: Subscription;

  constructor(private service: SponsorsService, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle(`Sponsors | CODE Hospitality CMS`);
    this.sub$ = this.service.getAll().subscribe(result => {
      this.sponsors = result;
      this.loading = false;
    });
  }

  ngOnDestroy() {
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/sponsors-listing/sponsors-listing.component.ts